export default __webpack_public_path__ + "static/media/adchoices.2b39834a.svg";